<template>
  <label class="ms-checkbox">
    <input
      type="checkbox"
      :value="value"
      class="ms-checkbox-control"
      :readOnly="readOnly"
      :checked="value"
      :disabled="disabled"
      v-on="listeners"
    />
    <span class="checkmark"></span>
    <span v-if="text" class="ms-checkbox--text">{{ text }}</span>
  </label>
</template>
<script>
export default {
  name: "msCheckbox",
  props: {
    value: {
      type: Boolean,
    },
    text: {
      default: null,
      type: String,
    },
    disabled: {
      default: false,
      type: [Boolean, Function],
    },
    readOnly: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    onFocus(e) {
      const me = this;
      me.focused = true;
    },
    onBlur(e) {
      const me = this;
      me.focused = false;
    },
  },
  data() {
    return {
      focused: false,
    };
  },
  computed: {
    listeners() {
      const me = this;
      return {
        click: (event) => {
          me.$emit("click", event);
        },
        input: (event) => {
          me.$emit("input", !me.value);
        },
        change: (event) => {
          me.$emit("change", event.target.checked);
        },
        focus: (event) => {
          me.onFocus(event);
        },
        blur: (event) => {
          me.onBlur(event);
        },
      };
    },
  },
};
</script>
<style lang="scss" scoped>
// @media screen and (max-width: 1366px) {
//   @import "@/assets/scss/_sm-variables.scss";
//   @import "@/assets/scss/components/msCheckbox.scss";
// }
// @media screen and (min-width: 1367px) {
//   @import "@/assets/scss/_variables.scss";
//   @import "@/assets/scss/components/msCheckbox.scss";
// }
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/components/msCheckbox.scss";
</style>
